import React, { useState } from 'react';
import { useSimulatorRoutes } from 'hooks';
import { isPresentedList } from 'utils/collection';
import {
  LessonBaseDto,
  LessonCompletedDto,
} from '@peartherapeutics/hylia-api-client';
import CompletedLessonsList from './CompletedLessonsList';
import IncompletedLessons from './IncompletedLessons';
import WidgetWrapper from '../Widgets/WidgetWrapper';
import { BlockTop, BlockBottom } from '../Widgets/Blocks';
import styles from './styles.module.scss';

export interface IOwnProps {
  total: number;
  completedLessons: LessonCompletedDto[];
  incompletedLessons: Pick<LessonBaseDto, 'name'>[];
  subtitle: string;
  isProcessing: boolean;
}

type WidgetLessonsType = IOwnProps;

const ButtonShowNextLessons = () => (
  <>
    <span className={styles.label}>Next 4 lessons</span>
    <div className={styles['right-arrow']} />
  </>
);

const ButtonShowLessonsCompleted = () => (
  <>
    <div className={styles['left-arrow']} />
    <span className={styles.label}>Lessons Completed</span>
  </>
);

const WidgetLessons = (props: WidgetLessonsType) => {
  const {
    total,
    completedLessons,
    incompletedLessons,
    subtitle,
    isProcessing,
  } = props;
  const routes = useSimulatorRoutes();
  const [isShowingIncompleteLessons, setIsShowingIncompleteLessons] =
    useState<boolean>(false);

  const onToggleShownList = () => {
    setIsShowingIncompleteLessons(!isShowingIncompleteLessons);
  };

  const title = isProcessing ? '' : `${total}`;

  return (
    <WidgetWrapper testId="widget-lessons" ariaLabel="Lesson Completion Widget">
      <BlockTop
        title={title}
        subtitle={subtitle}
        customComponent={
          isPresentedList(incompletedLessons) ? (
            <div
              onClick={onToggleShownList}
              className={styles['btn-toggle-list']}
            >
              {isShowingIncompleteLessons ? (
                <ButtonShowLessonsCompleted />
              ) : (
                <ButtonShowNextLessons />
              )}
            </div>
          ) : null
        }
      />
      {isShowingIncompleteLessons ? (
        <IncompletedLessons
          incompletedLessons={incompletedLessons.slice(0, 4)}
        />
      ) : (
        <CompletedLessonsList completedLessons={completedLessons} />
      )}
      <BlockBottom
        link={routes.PATIENT_DASHBOARD_LESSONS}
        text="Go To Lessons"
      />
    </WidgetWrapper>
  );
};

export default WidgetLessons;
